<template>
    <div>
        <div style="position:relative; height:60px;">
            <div style="display: flex; position: fixed; z-index: 10; right: 0; align-items: center; gap: 20px; padding-right: 14px; padding-top: 16px;">
                <div @click="showSearch">
                    <img style="width: 20px;" :src="require('@/assets/img/search_gray2.png')" alt="">
                </div>
                <AlarmIcon></AlarmIcon>
            </div>
            <div style="margin-top: 14px;">
                <div style="text-align: center;">
                    <img style="width: 80px;" :src="require('@/assets/img/soccerhow_logo_text.png')" alt="">
                </div>
            </div>
        </div>
        <div style="flex:1; overflow: auto;">
            <div v-if="home_banners_top.length > 0" style="margin-top: 12px; padding-bottom: 32px;">
                <SwipedHomeBanner style="padding-bottom: 0;" :home_banners="home_banners_top" />
            </div>
            <template v-if="!isExpert">
                <!-- 일반 회원 -->
                <div>
                    <div style="padding-bottom: 32px;">
                        <div style="display: flex; padding: 0 12px; align-items: center; margin-bottom: 12px; justify-content: space-between;">
                            <div style="display: flex; align-items: center; gap: 6px;">
                                <div style="font-weight: 700; line-height: 15px;">🔥 지금 뜨는 그라운드</div>
                            </div>
                            <div class="show_whole" @click="goSoccerLearn">
                                <div style="color: var(--color-main);">전체 보기</div>
                                <div>
                                    <img style="width: 6px;" :src="require('@/assets/img/arrow_orange_new.png')" alt="">
                                </div>
                            </div>
                        </div>
                        <div>
                            <GroundNews :groundList="groundNews"></GroundNews>
                        </div>
                    </div>
                    <div v-if="home_banners_top.length > 0" style="padding-bottom: 32px;">
                        <SwipedEventBanner style="padding-bottom: 0;" :home_banners="home_banners_top" />
                    </div>
                    <div v-if="$GlobalStore.isLogin()" style="">
                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 12px; margin-bottom: 24px;">
                            <div style="display: flex; gap: 9px; align-items: center;">
                                <div style="font-weight: 700;">🎯 {{ $GlobalStore.loginInfo() ? $GlobalStore.loginInfo().nic_name : '' }}님을 위한 맞춤 구단</div>
                                <!-- <div @click="showPopupMenuModal" style=" display: flex; align-items: center; gap: 4px; border: 1px solid #b2b2b2; border-radius: 5px; padding: 4px;">
                                    <div style="font-weight: 700; font-size: 12px;">{{ selectedFilter }}</div>
                                    <img style="width: 10px;" :src="require('@/assets/img/filter_arrow.png')" alt="">
                                </div> -->
                                <div style="font-weight: 700; font-size: 12px; color: #1f59e8; margin-top: 2px; background-color: #ecf5fe; border: 1px solid #d6e7fd; border-radius: 5px; padding: 3px 7px;">AI추천</div>
                            </div>
                            <div class="show_whole" @click="showAllTeam">
                                <div style="color: var(--color-main);">전체 보기</div>
                                <div>
                                    <img style="width: 6px;" :src="require('@/assets/img/arrow_orange_new.png')" alt="">
                                </div>
                            </div>
                        </div>
                        <div style="padding: 0 24px;">
                            <JoinSoccerTeamWrapper :teamList="canJoinSoccerTeam"></JoinSoccerTeamWrapper>
                        </div>
                    </div>
                    <div v-if="home_banners_middle.length > 0" style="margin-top: 32px;">
                        <SwipedHomeBannerSmall style="padding-bottom: 0;" :home_banners="home_banners_middle" />
                    </div>
                    <div style="margin-top: 32px; margin-bottom: 32px;">
                        <div style="font-weight: 700; padding: 0 12px; margin-bottom: 12px; display: flex; align-items: center; justify-content: space-between;">
                            <div>🎥 감독 인터뷰</div>
                            <div class="show_whole" @click="showSpotliteList">
                                <div style="color: var(--color-main);">전체 보기</div>
                                <div>
                                    <img style="width: 6px;" :src="require('@/assets/img/arrow_orange_new.png')" alt="">
                                </div>
                            </div>
                        </div>
                        <SwipedSelectedSpotLight style="padding-bottom: 0;" :spotlights="spotlights" />
                    </div>
                    <!-- <div style="margin-top: 15px;">
                        <div style="font-weight: 700; padding: 0 12px;">추천 감독/코치</div>
                        <div style="margin-top: 15px; border-bottom: 1px solid #f5f5f5; padding-bottom: 15px;">
                            <RecommendCoachWrapper :coachList="recommendCoach"></RecommendCoachWrapper>
                        </div>
                    </div> -->
                    <!-- <div style="border-bottom: 1px solid #f5f5f5; padding: 15px 12px;" v-for="each, i in pollList" :key="i + 'poll'">
                        <CommonPollPost :completeAction="hidePollList" :index="i" :pollPost="each"></CommonPollPost>
                    </div> -->
                    <!-- <div style="margin-top: 30px;">
                        <div style="font-weight: 700; padding: 0 12px;">친구 추천</div>
                        <div style="margin-top: 12px;">
                            <RecommendFriendsWrapper :userList="recommendUser"></RecommendFriendsWrapper>
                        </div>
                    </div> -->
                    <!-- <div style="margin-top: 30px; padding-bottom: 36px;">
                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 12px; margin-bottom: 12px;">
                            <div style="font-weight: 700; line-height: 24px;">지역별 멤버톡</div>
                            <div @click="showAllMemberTalk" style="font-size: 14px; font-weight: 500; color: #808080; line-height: 18px; color: #808080;">모든 멤버톡 보기</div>
                        </div>
                        <div class="hide_scroll" style="display: flex; overflow-x: scroll; gap: 16px;  padding: 0 12px;">
                            <div @click="openChat(each.region, each); $Util.sendEventClick('채팅_지역별멤버톡', true)" v-for="each, i in nationwideList" :key="i + 'nationwide'">
                                <MemberTalkBox :nationwideList="each" :boxType="MEMBER_TALK_BOX_TYPE.MEMBER_TALK"></MemberTalkBox>
                            </div>
                        </div>
                    </div> -->
                </div>
            </template>
            <template v-else>
                <div style="padding-bottom: 32px;">
                    <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 12px; margin-bottom: 12px;">
                        <div style="font-weight: 700;">⚡ 지금 도착한 새로운 유망주️</div>
                        <div class="show_whole" @click="showJoinSoccerTeam">
                            <div style="color: var(--color-main);">전체 보기</div>
                            <div>
                                <img style="width: 6px;" :src="require('@/assets/img/arrow_orange_new.png')" alt="">
                            </div>
                        </div>
                    </div>
                    <div style="padding: 0 12px;">
                        <div style="">
                            <RecentJoinRequestWrapper :requestFormList="recentJoinRequestForm"></RecentJoinRequestWrapper>
                        </div>
                        <!-- <div  style="width: 166px; line-height: 24px; padding: 7px 0; border-radius: 10px; border: 2px solid #210F031A; font-size: 14px; font-weight: 500; text-align: center; margin: 0 auto; margin-top: 15px;">입단 요청서 살펴보기</div> -->
                    </div>
                </div>
                <div v-if="home_banners_top.length > 0" style="padding-bottom: 32px;">
                    <SwipedEventBanner style="padding-bottom: 0;" :home_banners="home_banners_top" />
                </div>
                <div style="margin-bottom: 32px;">
                    <div style="display: flex; padding: 0 12px; align-items: center; margin-bottom: 12px; justify-content: space-between;">
                        <div style="display: flex; align-items: center; gap: 6px;">
                            <div style="font-weight: 700; line-height: 15px;">🔥 지금 뜨는 그라운드 </div>
                        </div>
                        <div class="show_whole" @click="goSoccerLearn">
                            <div style="color: var(--color-main);">전체 보기</div>
                            <div>
                                <img style="width: 6px;" :src="require('@/assets/img/arrow_orange_new.png')" alt="">
                            </div>
                        </div>
                    </div>
                    <div>
                        <GroundNews :groundList="groundNews"></GroundNews>
                    </div>
                </div>
                <div v-if="home_banners_middle.length > 0" style="margin-bottom: 32px;">
                    <SwipedHomeBannerSmall style="padding-bottom: 0;" :home_banners="home_banners_middle" />
                </div>
                <div style="margin-bottom: 32px;">
                    <div style="font-weight: 700; padding: 0 12px;">🎯 {{ $GlobalStore.loginInfo().name }}님을 위한 맞춤 선수</div>
                    <div style="margin-top: 12px;">
                        <RecommendFriendsWrapper :userList="recommendUser"></RecommendFriendsWrapper>
                    </div>
                </div>
            </template>

            <!-- 배너 -->
            <!-- <div v-if="home_banners.length === 0" style="padding: 0 12px; padding-bottom: 32px; margin-top: 12px;">
                <div style="height: 103px; background-color: #F5F5F5; border-radius: 12px;"></div>
            </div> -->
            <!-- 화면 이동 -->
            <!-- <div style="display:flex; gap:12px; padding:0px 12px; height:120px;">
                <div class="page_move_container" style="" @click="goSoccerLearn">
                    <div style="flex:1; display:grid; place-items: center;">
                        <img v-if="!is_soccer_learn_clicked" :src="require('@/assets/img/home_page_move_question_off.png')" style="width:60px; height:60px;filter: drop-shadow(0px 4px 10px rgba(33, 15, 3, 0.2));">
                        <img v-else :src="require('@/assets/img/home_page_move_question_on.png')" style="width:60px; height:60px;filter: drop-shadow(0px 4px 10px rgba(33, 15, 3, 0.2));">
                    </div>
                    <div class="btn_name gradient_color">축구 질문하기</div>
                    <div v-if="home_event_btns_flags.soccer_learn && home_event_btns_flags.soccer_learn === true" class="event_btn">이벤트</div>
                </div>
                <div class="page_move_container" style="overflow: hidden;" @click="goSoccerJoin">
                    <AutoScrollWrapper style="flex:1; display:flex; align-items: center;" :scrollDirection="SCROLL_DIRECTION.LEFT">
                        <div v-for="each, i in teams" :key="i" style="display:inline-block; margin-left:20px;">
                            <img :src="$resourcePath + each.image_path" style="width:60px; height:60px;" />
                        </div>
                    </AutoScrollWrapper>
                    <div class="btn_name gradient_color">축구팀 입단하기</div>
                    <div v-if="home_event_btns_flags.soccer_join && home_event_btns_flags.soccer_join === true" class="event_btn">이벤트</div>
                </div>
            </div> -->

            <!-- <div style="display:flex; gap:6px; padding:0px 12px; height:114px; margin-top:20px;">
                <div class="page_move_container" style="" @click="showActiveRank(); $Util.sendEventClick('홈_만보기', true)">
                    <PedometerHome></PedometerHome>
                </div>
                <div class="page_move_container" style="flex: 0; flex-basis: 120px;" @click="showPosition">
                    <div style="flex:1; display:grid; place-items: center;">
                        <img :src="require('@/assets/img/home_page_move_position.png')" style="width:60px; height:60px;">
                    </div>
                    <div class="btn_name">포지션 찾기</div>
                    <div v-if="home_event_btns_flags.position && home_event_btns_flags.position === true" class="event_btn">이벤트</div>
                </div>
            </div> -->
            <!-- 실시간 입단 소식 -->
            <!-- <div class="label" style="margin-top:30px;">실시간 입단 소식</div>
            <div style="padding:0px 12px; margin-top:10px;" @click="showRealTimeNews">
                <AutoScrollWrapper :scrollDirection="SCROLL_DIRECTION.TOP" style="height:120px;padding: 16px 12px; background-color: #F5F5F5; border-radius:16px;">
                    <div v-for="each, i in real_time_news" :key="i" :style="{ marginBottom: i + 1 === real_time_news.length ? '0' : '16px' }" style="display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 32px;">
                        <div>
                            <div style="color: #606060; font-weight: 700; font-size: 14px; line-height: 20px; margin-bottom: 4px;">{{ each.from_member.team ? each.from_member.team.name : '' }}</div>
                            <div style="line-height: 20px; font-size: 14px; font-weight: 500;">
                                <span>{{ each.from_member.nic_name }}</span> 감독,
                                <span style="font-weight: 700;">
                                    <span>{{ each.to_member.nic_name }}</span>
                                    <span style="font-weight: 700; color: var(--color-main);">
                                        <DivisionPositionText :position="each.to_member.position" :positionProAbility="each.to_member.position_pro_ability"></DivisionPositionText>
                                    </span>
                                </span>
                                <span v-if="each.news_type == REAL_TIME_NEWS_TYPE.SCOUT">를 스카웃했습니다. 👏</span>
                                <span v-else>에게 관심을 갖고 있습니다.🤔</span>
                            </div>
                            <div style="margin-top: 8px; font-size: 12px; font-weight: 500; line-height: 20px; color: #606060;">{{ each.insert_date | agoDateStr }}</div>
                        </div>
                        <div style="height: 60px; width: 60px; flex-shrink: 0; border-radius: 12px; overflow: hidden;" v-if="each.from_member.team && each.from_member.team.image_path">
                            <img style="width: 100%; height: 100%;" :src="each.from_member.team ? $resourcePath + each.from_member.team.image_path : ''" alt="">
                        </div>
                    </div>
                </AutoScrollWrapper>
            </div> -->

            <!-- 가까운 축구 트레이닝 -->
            <!-- <template v-show="$GlobalStore.isLogin()">
                <div class="label" style="margin-top:30px;">주변에 입단할 수 있는 축구팀{{ detectLogin }}</div>
                <div style="padding:0 12px; margin-top:10px;" @click.stop="goJoinMain">
                    <div id="home_map" style="height:120px; border-radius:12px;"></div>
                </div>
            </template> -->
            <!-- 스포트 라이트 -->

        </div>
        <PageBottom />
        <PopupBanner v-show="popupBanners.length > 0" :isShowPopupBanner="isShowPopupBanner" :banners="popupBanners" :hide="() => { isShowPopupBanner = false }"></PopupBanner>
        <!-- 포지션 찾기 팝업 -->
        <Transition name="fade">
            <div v-if="$GlobalStore.isShowPositionPopup()" style="position: fixed; z-index: 200; background: #210F0380; width: 100%; height: 100%; left: 0; top: 0; backdrop-filter: blur(10px);">
                <div style="width: 350px; padding-bottom: 40px; text-align: center; border-radius: 24px; background-color: #fff; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                    <div @click="$GlobalStore.closePositionPopup()" style="font-weight: 700; line-height: 24px; padding-top: 16px; color: #808080; text-align: left; padding-left: 20px; margin-bottom: 20px;">닫기</div>
                    <div>
                        <img style="width: 204px;" :src="require('@/assets/img/position_stat.png')" alt="">
                    </div>
                    <div style="font-weight: 700; font-size: 20px; line-height: 32px; margin-top: 44px;">회원님의 진짜<br>포지션을 알아보세요</div>
                    <div style="margin-top: 8px; font-weight: 500; font-size: 14px; line-height: 24px; color: #606060;">전문가들이 직접 만든 알고리즘으로<br>회원님의 진짜 축구 포지션을 알아보세요</div>
                    <div @click="showPosition(); $Util.sendEventClick('포지션팝업_포지션찾기', true)" style="width: 196px; height: 56px; line-height: 56px; text-align: center; font-weight: 700; font-size: 14px; color: var(--color-main); margin: 0 auto; background-color: #210f03; border-radius: 50px; margin-top: 40px;">지금 포지션 찾기</div>
                </div>
            </div>
        </Transition>
        <div style="position: relative; z-index: 300;">
            <MakeRequestJoinForm :isShowMakeRequestJoinForm="isShowMakeRequestJoinForm" :closeRequestJoinForm="closeRequestJoinForm"></MakeRequestJoinForm>
        </div>
        <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="menuOptions"></BottomPopupMenu>
    </div>
</template>

<script>
import ResponseCode from '@/ResponseCode'
import AlarmIcon from "../common/AlarmIcon";
import SwipedSelectedSpotLight from "../common/spotlight/SwipedSelectedSpotLight";
import { PAGE_NAME, REAL_TIME_NEWS_TYPE, HOME_POPUP_TODAY_CLOSE_DATE, SCROLL_DIRECTION, VISIT_REASON_TYPE, OPEN_CHAT_REGIONS, MEMBER_TALK_BOX_TYPE } from "../../Constants";
import SwipedHomeBanner from "@/components/common/home/SwipedHomeBanner";
import SwipedEventBanner from "@/components/common/home/SwipedEventBanner";
import SwipedHomeBannerSmall from "@/components/common/home/SwipedHomeBannerSmall";
import PageBottom from "../common/PageBottom";
import NaverMap from "@/modules/NaverMap";
import PopupBanner from "../common/PopupBanner";
import moment from 'moment';
import MakeRequestJoinForm from '@/components/soccerhowmain/MakeRequestJoinForm';
// import CommonPollPost from '@/components/common/CommonPollPost'
import JoinSoccerTeamWrapper from "@/components/common/JoinSoccerTeamWrapper";
// import RecommendCoachWrapper from "@/components/common/RecommendCoachWrapper.vue";
import RecommendFriendsWrapper from "@/components/common/RecommendFriendsWrapper.vue";
import RecentJoinRequestWrapper from "@/components/common/RecentJoinRequestWrapper.vue";
import GroundNews from "@/components/common/GroundNews.vue";
// import MemberTalkBox from "@/components/common/MemberTalkBox";
import BottomPopupMenu from "@/components/common/BottomPopupMenu";

export default {
    name: "Home",
    components: { PopupBanner, BottomPopupMenu, SwipedEventBanner, SwipedHomeBannerSmall, RecentJoinRequestWrapper, RecommendFriendsWrapper, GroundNews, JoinSoccerTeamWrapper, MakeRequestJoinForm, PageBottom, SwipedHomeBanner, SwipedSelectedSpotLight, AlarmIcon },
    data() {
        return {
            VISIT_REASON_TYPE: VISIT_REASON_TYPE,
            REAL_TIME_NEWS_TYPE: REAL_TIME_NEWS_TYPE,
            home_banners_top: [],
            home_banners_middle: [],
            teams: [],
            real_time_news: [],
            spotlights: [],
            is_soccer_learn_clicked: false,
            home_event_btns_flags: {},
            map: null,
            popupBanners: [],
            nationwideList: OPEN_CHAT_REGIONS,
            MEMBER_TALK_BOX_TYPE: MEMBER_TALK_BOX_TYPE,
            isShowPopupBanner: false,
            isShowMakeRequestJoinForm: false,
            test: true,
            SCROLL_DIRECTION: SCROLL_DIRECTION,
            is_mounted: false,
            visitReasonType: this.$GlobalStore.getVisitReasonType(),
            pollList: [],
            isCompleteGetPollList: false,
            canJoinSoccerTeam: [],
            recommendCoach: [],
            recommendUser: [],
            recentJoinRequestForm: [],
            groundNews: [],
            menuOptions: {},
            isShowPopMenu: false,
            selectedFilter: '모든 나이대',
            age: null,
            team_cnt: 0
        }
    },
    computed: {
        detectLogin() {
            if (this.$store.state.loginInfo && this.$store.state.loginInfo.idx && this.is_mounted) {
                this.actDelayTime(this.setMap);
                return '';
            } else {
                return '';
            }
        },
        isExpert() {
            if (this.$GlobalStore.loginInfo() && this.$GlobalStore.loginInfo().is_temp_coach === '1') {
                return true
            } else {
                return false
            }
        },
    },
    methods: {
        showSpotliteList() {
            this.$GlobalStore.addModal('SpotLightList',)
        },
        showAllMemberTalk() {
            this.$GlobalStore.addModal('AllMemberTalkPopup', { isModalBackTransparent : true, transitionName: 'top' })
        },
        showPopupMenuModal() {
            this.isShowPopMenu = true
            const labelAndAction = []
            labelAndAction.push(
                {
                    label: '모든 나이대', action: () => {
                        this.isShowPopMenu = false
                        this.selectedFilter = '모든 나이대'
                        this.age = null
                        this.getSuitableSoccerTeam()
                    },
                },
                {
                    label: '초등학교', action: () => {
                        this.isShowPopMenu = false
                        this.selectedFilter = '초등학교'
                        this.age = 'U12'
                        this.getSuitableSoccerTeam()
                    },
                },
                {
                    label: '중학교', action: () => {
                        this.isShowPopMenu = false
                        this.selectedFilter = '중학교'
                        this.age = 'U15'
                        this.getSuitableSoccerTeam()
                    },
                },
                {
                    label: '고등학교', action: () => {
                        this.isShowPopMenu = false
                        this.selectedFilter = '고등학교'
                        this.age = 'U18'
                        this.getSuitableSoccerTeam()
                    },
                },
                {
                    label: '대학교', action: () => {
                        this.isShowPopMenu = false
                        this.selectedFilter = '대학교'
                        this.age = '대학팀'
                        this.getSuitableSoccerTeam()
                    },
                },
            )

            this.menuOptions = {
                labelAndAction: labelAndAction,
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            }
        },
        async openChat(region_name, regionInfo) {
            if (this.$GlobalStore.isLogin()) {
                const openChatKey = `${region_name} 오픈 멤버톡`
                const parameters = {};
                parameters.open_chat_name = openChatKey;
                const res = await this.$Axios.post('/api/chat/check/joined/openchat', parameters);
                if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                    return;
                }
                await this.$Axios.showChattingBySoccerJoinIdx(res.data.chat_idx, () => { }, false, () => { }, regionInfo);
            }

            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
        },
        showAllTeam() {
            this.$router.push({ path: '/view/soccer_join' + '?isFromHome=true' +  '&time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
        },
        showJoinSoccerTeam() {
            this.$router.push({ path: '/view/soccer_join' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
        },
        async getPollList(isRefresh) {
            if (isRefresh) {
                this.pollList = []
            }
            const res = await this.$Axios.get('/api/poll/list')

            const pollList = res.data.poll_list
            this.pollList = pollList
            this.pollList = this.pollList.filter(poll => !poll.is_me_poll_hidden)
            this.isCompleteGetPollList = true
        },
        hidePollList(index) {
            this.$delete(this.pollList, index)
        },
        actDelayTime(callback) {
            if (document.getElementById('home_map').getBoundingClientRect().width === 0) {
                setTimeout(() => {
                    callback();
                }, 3000);
            } else {
                callback();
            }
        },
        showActiveRank() {
            this.$GlobalStore.addModal('ActivityRanking')
        },
        setIsShowMakeRequestJoinForm() {
            this.isShowMakeRequestJoinForm = true
        },
        closeRequestJoinForm() {
            this.isShowMakeRequestJoinForm = false
        },
        checkPopupBanner() {
            this.isShowPopupBanner = true;
            if (this.$hasOwnProperty(localStorage, HOME_POPUP_TODAY_CLOSE_DATE)) {
                const today = moment().format('YYYY-MM-DD');
                if (today === localStorage.getItem(HOME_POPUP_TODAY_CLOSE_DATE)) this.isShowPopupBanner = false;
            }
        },
        goTrainingMain() {
            this.$Util.sendEventClick('홈_가까운_축구_트레이닝', true);
            this.$router.push({ path: '/training_main?time=' + new Date().getTime() });
        },
        goJoinMain() {
            this.$Util.sendEventClick('홈_주변에입단할수있는팀', true);
            this.$router.push({ path: '/view/mercenary?time=' + new Date().getTime() });
        },
        goSoccerLearn() {
            this.is_soccer_learn_clicked = true;
            this.$Util.sendEventClick('홈_축구_질문하기', true);
            setTimeout(() => {
                this.is_soccer_learn_clicked = false;
                this.$router.push({ path: '/view/soccer_learn?time=' + new Date().getTime() });
            }, 300)
        },
        goSoccerJoin() {
            this.$Util.sendEventClick('홈_축구팀_입단하기', true);
            this.$router.push({ path: '/view/mercenary?time=' + new Date().getTime() + '&is_from_home=true' });
            // this.$router.push({ path: '/view/soccer_join?time=' + new Date().getTime() });
        },
        goReporting() {
            this.$Util.sendEventClick('홈_다이렉트_요청서');
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }

            if (this.$GlobalStore.loginInfo().is_temp_coach == '1') {
                this.$router.push({ path: '/view/mychat?time=' + new Date().getTime() + '&is_direct_message=true' });
            } else {
                this.$GlobalStore.addModal('RequestReportList');
            }
        },
        showPosition() {
            this.$Util.sendEventClick('홈_포지션_찾기', true);
            // this.$GlobalStore.addModal('FindPositionProMain', {});
            this.$GlobalStore.addModal('SelectFindPosition')
        },
        goMemberTalk() {
            this.$Util.sendEventClick('홈_멤버톡');
            this.$router.push({ path: '/view/mychat?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
        },
        setIsSaveRecommendCoach(recommend_coach_list) {
            const RECOMMEND_COACH_LIST = 'RECOMMEND_COACH_LIST'
            const RECOMMEND_COACH_LIST_TIME = 'RECOMMEND_COACH_LIST_TIME'

            const recommendCoachList = localStorage.getItem(RECOMMEND_COACH_LIST)
            const recommendCoachListTime = localStorage.getItem(RECOMMEND_COACH_LIST_TIME)

            const today = moment().format('YYYY-MM-DD')
            const isPassOneDay = today === recommendCoachListTime ? false : true

            if (isPassOneDay) {
                this.recommendCoach = recommend_coach_list
                localStorage.setItem(RECOMMEND_COACH_LIST, JSON.stringify(this.recommendCoach))
                localStorage.setItem(RECOMMEND_COACH_LIST_TIME, today)
            } else {
                this.recommendCoach = JSON.parse(recommendCoachList)
            }
        },
        setIsSaveCoachInterview(spotlights) {
            const INTERVIEW_LIST = 'INTERVIEW_LIST'
            const INTERVIEW_LIST_TIME = 'BANNER_LIST_TIME'

            const interviewList = localStorage.getItem(INTERVIEW_LIST)
            const interviewListTime = localStorage.getItem(INTERVIEW_LIST_TIME)

            const today = moment().format('YYYY-MM-DD')
            const isPassOneDay = today === interviewListTime ? false : true

            if (isPassOneDay) {
                this.spotlights = spotlights
                localStorage.setItem(INTERVIEW_LIST, JSON.stringify(this.spotlights))
                localStorage.setItem(INTERVIEW_LIST_TIME, today)
            } else {
                this.spotlights = JSON.parse(interviewList)
            }
        },
        async getSuitableSoccerTeam() {
            const parameters = {}
            if (this.age) {
                parameters.age = this.age
            }
            const res = await this.$Axios.get('/api/home/suitable_teams', { params: parameters })
            this.canJoinSoccerTeam = res.data.can_join_soccer_team;
            this.team_cnt = res.data.team_cnt
        },
        async getHomeData() {
            const parameters = {}
            parameters.is_coach = this.isExpert
            parameters.page_type = 'home'
            const res = await this.$Axios.get('/api/home', { params: parameters });
            this.exceptionManager()
            if (!this.isExpert) {
                // this.setIsSaveRecommendCoach(res.data.recommend_coach)
                this.setIsSaveCoachInterview(res.data.spotlights)
                this.popupBanners = res.data.popup_banners;
                this.groundNews = res.data.ground_news
                this.recentJoinRequestForm = res.data.recent_join_request_form;
            } else {
                this.recentJoinRequestForm = res.data.recent_join_request_form;
                this.groundNews = res.data.ground_news
            }
            this.checkPopupBanner();
        },
        async getRecommendUser() {
            const res = await this.$Axios.get('/api/recommend_member/random')

            this.recommendUser = res.data.members
        },
        exceptionManager() {
            if (process.env.NODE_ENV === 'production') {
                this.real_time_news = this.real_time_news.filter(item =>
                    item.from_member_idx != 462310 && item.to_member_idx != 462310
                );
            }
        },
        async getHomeDataSub() {
            const res = await this.$Axios.get('/api/home/sub');
            this.home_banners_top = res.data.home_banners_top;
            this.home_banners_middle = res.data.home_banners_middle;
            this.teams = res.data.teams;
        },
        showSearch() {
            let pageName = '';
            pageName = PAGE_NAME.SOCCER_TEAM;
            this.$Util.sendEventClick('홈_검색아이콘_클릭', true)
            this.$GlobalStore.addModal('IntergrationSearch', { pageName: pageName })
        },
        showRealTimeNews() {
            this.$Util.sendEventClick('홈_실시간_입단_소식', true)
            this.$GlobalStore.addModal('SoccerhowRealTimeNews')
        },
        async setMap() {
            const map = new NaverMap();
            map.initMap('home_map', this.$GlobalStore.loginInfo().place_gps_latitude, this.$GlobalStore.loginInfo().place_gps_longitude,
                { zoom: 11, minZoom: 7, maxZoom: 17, draggable: false, scrollWheel: false, logoControl: true }
            );
            this.map = map;
            this.naverMap = this.map;

            //네이버 로고 내리기
            setTimeout(() => {
                const home_map = document.getElementById('home_map');
                if (home_map) {
                    const map_children = document.getElementById('home_map').childNodes;
                    for (const each of map_children) {
                        each.style.zIndex = 0
                    }
                }
            }, 1000);
            // this.getTraining();
            this.getTeam();
        },
        async getTeam() {
            const parameters = {};
            parameters.gps_latitude = this.$GlobalStore.loginInfo().place_gps_latitude;
            parameters.gps_longitude = this.$GlobalStore.loginInfo().place_gps_longitude;

            const res = await this.$Axios.get('/api/team/map/list', { params: parameters })

            const teams = res.data.teams;

            let overlayCreatorSoccerList = (item, html, lat, lng, zIndex) => {
                let handler = () => { }
                this.naverMap.drawOverlay(html, lat, lng, html, handler, zIndex);
            }

            teams.forEach(item => {
                const markerHtml = this.$Util.Mercenary.Marker.soccerTeamMarker(item)
                overlayCreatorSoccerList(item, markerHtml, item.place.place_gps_latitude || item.place.gps_latitude, item.place.place_gps_longitude || item.place.gps_longitude, 10)
            })
        },
        async getTraining() {
            const parameters = {};

            const res = await this.$Axios.get('/api/home/training', { params: parameters });

            const handler = () => { }

            for (const each of res.data.schedules) {
                const html = this.$Util.Mercenary.Marker.trainingMarker(each)
                this.naverMap.drawOverlay(html, each.gps_latitude, each.gps_longitude, html, handler);
            }
        }
    },
    mounted() {
        this.is_mounted = true;
        // if (this.$GlobalStore.isLogin()) {
        //     this.setMap();
        // }
    },
    created() {
        this.openChat = this.$Once(this.openChat)
        this.getHomeDataSub();
        this.getRecommendUser()
        this.getHomeData();
        if (this.$GlobalStore.isLogin()) {
            this.getSuitableSoccerTeam()
        }
    }
}
</script>

<style scoped>
.show_whole {
    font-size: 12px; 
    font-weight: 500; 
    display: flex; 
    gap: 6px; 
    align-items: center;
}

.label {
    padding: 0px 12px;
    font-weight: bold;
    font-size: 14px;
}

.event_btn {
    position: absolute;
    left: 4px;
    top: 4px;
    font-weight: bold;
    color: #210F03;
    font-size: 12px;
    border-radius: 8px;
    padding: 3px 8px;
    background-color: #FF7111;
    height: 22px;
    display: grid;
    place-items: center;
}

.page_move_container {
    flex: 1;
    position: relative;
    height: 100%;
    background-color: #F5F5F5;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
}

.btn_name {
    margin-bottom: 17px;
    text-align: center;
    color: #210F03;
    font-size: 14px;
    font-weight: 500;
}

.gradient_color {
    background: linear-gradient(90deg, #AF4700 0%, #0C3187 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
}
</style>